import React from "react";
import { SafeAreaView, StyleSheet, View, ImageBackground } from "react-native";
import Constants from "expo-constants";
import { StatusBar } from "expo-status-bar";
import AppTitleBar from "./AppTitleBar";
import AppButtonGoBack from "./buttons/AppButtonGoBack";
import PopUpBox from "./PopUpBox";
import ActivityIndicator from "./ActivityIndicator";
import Loader from "./Loader";

function ScreenReskin({
    children,
    style,
    title,
    navigation,
    leftIconComponent,
    midLeftIconComponent,
    midRightIconComponent,
    rightIconComponent,
    subTitle,
    titleComponent,
    message,
    setMessage,
    yesNo,
    loading,
    showTitleBar = true,
}) {
    return (
        <SafeAreaView style={[styles.screen, style]}>
            <Loader visible={loading} />

            <PopUpBox message={message} setMessage={setMessage} yesNo={yesNo} />

            <View behavior="padding" style={[styles.view, style]}>
                {showTitleBar && (
                    <AppTitleBar
                        title={title}
                        subTitle={subTitle}
                        leftIconComponent={leftIconComponent ? leftIconComponent : <AppButtonGoBack onPress={() => navigation.goBack()} />}
                        midLeftIconComponent={midLeftIconComponent}
                        midRightIconComponent={midRightIconComponent}
                        rightIconComponent={rightIconComponent}
                        titleComponent={titleComponent}
                    />
                )}

                {children}
            </View>

            <StatusBar style="light" />
        </SafeAreaView>
    );
}

const styles = StyleSheet.create({
    screen: {
        paddingTop: Constants.statusBarHeight,
        flex: 1,
    },
    view: {
        flex: 1,
    },
    button: {
        borderRadius: 20,
        padding: 10,
        elevation: 2,
    },
});

export default ScreenReskin;
